module.exports = __webpack_public_path__ + "static/media/esays.46570ba5.JPG";